import React from 'react';
import './Register.css';

import { Logo, PageTitle } from '../../../components';

import { Link } from 'react-router-dom';



const Register = () => {

  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent the default form submission behavior
    // Reset the form fields
    event.target.reset();
  };

  return ( 
    <>
      {/* Page Title */}
      <PageTitle title={'register'} page={'register'} />

      <section className='register'>

        {/* Registration Form */}
        <form className='account-form' onSubmit={handleSubmit}>

          <h3>register</h3> {/* Heading for the register form */}

          <input type="text" name="name" placeholder="enter your name" id="name" className="box" /> {/* Name Input */}
          <input type="email" name="email" placeholder="enter your email" id="email" className="box" /> {/* Email Input */}
          <input type="password" name="password" placeholder="enter your password" id="password" className="box" /> {/* Password Input */}
          <input type="password" name="repeat-password" placeholder="repeat your password" id="repeat-password" className="box" /> {/* Repeat Password Input */}

          {/* Terms and Conditions Checkbox */}
          <div className="checkbox-label">
            <input type="checkbox" name="terms" id="terms" defaultChecked />
            <label htmlFor="terms">I agree with the <span>terms & conditions</span></label>
            <div className="checkbox-indicator"></div>
          </div>

          {/* Register Button */}
          <button type='submit' name='submit' id='submit' className='btn'>Register</button>

          {/* Login Link */}
          <p>already have an account? <Link to='/login' className='link'>login</Link></p>

        </form>
        
      </section> 
    </>
  );
}

export default Register;